export let ExperimentFetchStatus;
(function (ExperimentFetchStatus) {
  ExperimentFetchStatus["None"] = "NONE";
  ExperimentFetchStatus["Pending"] = "PENDING";
  ExperimentFetchStatus["Fetched"] = "FETCHED";
})(ExperimentFetchStatus || (ExperimentFetchStatus = {}));